export default __webpack_public_path__ + "static/media/balanceofnature.beb5e534.png";